import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '@sia/shared';

@Injectable({
  providedIn: 'root',
})
export class GridConfApi {
  private api = inject(SiaHttpService);

  private readonly apiController: string = 'grid-configs';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  getGridDefaultConfiguration(reference: any, gridId: string) {
    return this.api.get(
      `${this.apiController}/configurations/${gridId}/defaults/${reference}`,
      {},
    );
  }

  refreshGridConfiguration(perspective: string): Promise<any> {
    let params = new HttpParams();
    params = params.set('perspective', `${perspective}`);
    return this.api.get(`${this.apiController}/grid-conf-refresh`, { params });
  }
}
